
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 8 14"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"currentColor","d":"M6.45838 13.5187L.709 7.51877C.569344 7.37423.5 7.18673.5 7.00023s.069344-.37403.209-.51856L6.45838.481734c.286-.299812.76063-.309562 1.05944-.022469.30078.285157.31056.761715.02247 1.059565l-5.25148 5.4814 5.25148 5.48137c.28809.2969.27831.7744-.02247 1.0596-.29881.2871-.77344.2773-1.05944-.0225z"}})])
          )
        }
      }
    